import TokenStorage from "utils/TokenStorage.js";

/**
 * Organization domain used in the API `Organization` header cookie.
 * Derived from hostname subdomains (not the display labels in OrganizationUtils).
 */
export function resolveOrganizationDomain(hostname = window.location.hostname) {
  const parts = hostname.split(".");
  let subDomain =
    parts.length >= 3 ? parts.slice(0, -2).join(".") : parts[0] || hostname;

  if (subDomain === "localhost" || subDomain === "uat") {
    subDomain = "uat";
  }
  return subDomain;
}

/**
 * Persist runtime config shared by the SPA and standalone HTML forms.
 * Safe on every SPA boot and after login/session restore.
 */
export function bootstrapClientSession() {
  TokenStorage.ensureClientConfig({
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    organization: resolveOrganizationDomain(),
  });
}
